import { Mic, StopCircle } from 'lucide-react';
import { type ReactElement } from 'react';
import { Button } from '@avanta/shared/components/ui/Button';
import { CHAT_BUTTON_INPUT_CLASSNAME } from '@avanta/shared/constants/chat';

interface RecordButtonProps {
  onClick: () => void;
  isRecording: boolean;
  isSending: boolean;
}

export const RecordButton = ({
  onClick,
  isRecording,
  isSending,
}: RecordButtonProps): ReactElement => (
  <Button
    variant="ghost"
    icon="only"
    type="button"
    onClick={onClick}
    disabled={isSending}
    className={CHAT_BUTTON_INPUT_CLASSNAME}
  >
    {isRecording ? (
      <StopCircle className="size-5 text-red-500" />
    ) : (
      <Mic className="size-5 hover:bg-transparent" />
    )}
  </Button>
);
